export default function calculateCurrentPriceCircleProps(progress, currData, prevData, currDataFiltered, prevDataFiltered, layoutSize, color, path, currentPriceCircleRadius) {
    'worklet';
    if (currData && currData.length) {
        if (progress === 1) {
            if (currData.length === currDataFiltered.length) {
                // chart goes to the very right edge, no need for the circle
                return { cx: '-10', cy: '0', r: 0, fill: 'rgb(255, 0, 255)' };
            }
            // need to paint. First step is to define the color - red or green
            if (currDataFiltered.length) {
                const lastIndex = currDataFiltered.length - 1;
                const lastValue = currDataFiltered[lastIndex].y;
                return {
                    cx: (currDataFiltered[lastIndex].x * layoutSize.width).toString(),
                    cy: (lastValue * layoutSize.height).toString(),
                    r: currentPriceCircleRadius,
                    fill: color,
                };
            }
            return { cx: '-10', cy: '0', r: 0, fill: 'rgba(255, 255, 255, 0)' };
        }
        // animation in progress
        // parse path’s `d` string to extract last point coordinates
        const match = path.match(/L ([^\s]+) ([^\s]+)$/);
        if (match) {
            // determine if initial or final path doesn’t touch the right edge of screen
            const initialStateHasCircle = prevData && prevData.length && prevData.length !== prevDataFiltered.length;
            const finalStateHasCircle = currData && currData.length && currData.length !== currDataFiltered.length;
            if (initialStateHasCircle && finalStateHasCircle) {
                return {
                    cx: match[1],
                    cy: match[2],
                    r: currentPriceCircleRadius,
                    fill: color,
                };
            }
            if (finalStateHasCircle) {
                return {
                    cx: match[1],
                    cy: match[2],
                    r: progress * currentPriceCircleRadius,
                    fill: color,
                };
            }
            if (initialStateHasCircle) {
                return {
                    cx: match[1],
                    cy: match[2],
                    r: (1 - progress) * currentPriceCircleRadius,
                    fill: color,
                };
            }
        }
    }
    return { cx: '-10', cy: '0', r: 0, fill: 'rgba(255, 255, 255, 0)' };
}
